import React, { useState } from "react";
import { LuBuilding2 } from "react-icons/lu";
import { bmColors, emptyState } from "./bmStyles";

// The portal's front door: the buildings this manager holds.
//
// The greeting lives here rather than in the topbar, matching the field tech
// dashboard — a manager is welcomed once, on arrival, not on every screen they
// open afterwards. No name in it: managers are an outside audience and the
// plain word reads more formally than being greeted by first name.
//
// The list is read from the profile ManagerPortal already loaded from
// /api/bm/me/, photo and all, so there is no second request.
export function BMSites({ sites, onPick, isMobile }) {
  return (
    <div>
      <h1
        style={{
          fontSize: isMobile ? "20px" : "22px",
          fontWeight: "700",
          color: bmColors.darkGrey,
          margin: 0,
        }}
      >
        Welcome
      </h1>

      {!sites || sites.length === 0 ? (
        <div style={emptyState}>
          No buildings have been assigned to your account yet.
          <br />
          Contact Standard Fire Protection.
        </div>
      ) : (
        <div style={{ marginTop: "24px" }}>
          {sites.map((site) => (
            <SiteCard
              key={site.id}
              site={site}
              isMobile={isMobile}
              onPick={() => onPick(site)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

// One building: its address, then its photo. The address names the item, so it
// leads; the photo below is what makes it recognisable at a glance.
function SiteCard({ site, isMobile, onPick }) {
  const [hover, setHover] = useState(false);

  // A shape rather than a height, so the crop does not get more brutal the
  // wider the window gets. The cap is lower than the profile's on purpose —
  // a building here is a preview, not a second copy of its own profile page.
  const box = {
    width: "100%",
    aspectRatio: "16 / 9",
    maxHeight: "280px",
    borderRadius: "8px",
    border: `1px solid ${bmColors.border}`,
    display: "block",
  };

  return (
    <div
      onClick={onPick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onTouchStart={() => setHover(true)}
      onTouchEnd={() => setHover(false)}
      style={{
        padding: isMobile ? "12px 4px" : "12px 8px",
        borderBottom: `1px solid ${bmColors.border}`,
        backgroundColor: hover ? "#f8fafc" : "transparent",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          marginBottom: "10px",
          fontSize: isMobile ? "15px" : "16px",
          color: bmColors.text,
        }}
      >
        {site.site_name}
      </div>

      {site.street_view_photo_url ? (
        <img
          src={site.street_view_photo_url}
          // Decorative: the address sits directly above as real text, so a
          // screen reader should not read the building out twice.
          alt=""
          style={{ ...box, objectFit: "cover" }}
        />
      ) : (
        <div
          style={{
            ...box,
            backgroundColor: "#f8fafc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#cbd5e1",
          }}
        >
          <LuBuilding2 size={32} />
        </div>
      )}
    </div>
  );
}
